import { connect } from 'react-redux'
import FilterUI from './FilterUI'
import { Dispatch } from 'redux';
import ApplicationState from '../../../../../../../ApplicationState';
import IState from '../../../../../../Util/IState';
import IDispatcher from '../../../../../../Util/IDispatcher';
import FilterDispatch, { CustomFilterState } from './model';
import FilterDto, { PropsValueItem } from '../../../../../../../dto/FilterDto';
import { ActionType as IndexActionType } from '../../../Index/Actions/ActionTypes';
import { ActionType } from '../../Actions/ActionTypes';
import { actionFetchFiles } from '../../../Index/Actions/ActionCretor';

const mapStateToProps = (state: ApplicationState): IState<CustomFilterState> => {
    return {
        state: {
            filter: state.filter,
            home: state.home
        }
    }
}

const mapDispatchToProps = (dispatch: Dispatch): IDispatcher<FilterDispatch> => ({
    dispatcher: {
        open: (isOpen: boolean) => {
            dispatch({
                type: ActionType.FILTER_IS_OPEN,
                isOpen: isOpen
            })
        },
        reset: () => {
            dispatch({
                type: ActionType.FILTER_RESET
            })
        },
        type: (id: number) => {
            dispatch({
                type: ActionType.FILTER_TYPE_SELECTED,
                id: id
            })
        },
        tags: (ids: number[]) => {
            dispatch({
                type: ActionType.FILTER_TAGS_CHANGED,
                ids: ids
            })
        },
        address: (text: string) => {
            dispatch({
                type: ActionType.FILTER_ADDRESS_CHANGED,
                text: text
            })
        },
        props: (id: number, value: any | undefined, from: boolean) => {
            dispatch({
                type: ActionType.FILTER_PROPS_CHANGED,
                id: id,
                value: value,
                from: from
            })
        },
        filter: (filter: FilterDto) => {
            dispatch({
                type: IndexActionType.INDEX_RESET
            })
            dispatch({
                type: IndexActionType.INDEX_SET_FILTER,
                filter: filter
            })
            dispatch(actionFetchFiles(1, filter) as any)

        }
    }
})

export default connect(mapStateToProps, mapDispatchToProps)(FilterUI)